
<app-table
module="users"
pageTitle="Elenco utenti"
newRecordUrl="users/user-edit/new"
editRecordUrl="users/user-edit/update/"
deleteRecordUrl="users/user-edit/delete/"
listUrl="app/users_listall"></app-table>
	